import { getVariantEnvironment } from 'owa-metatags/lib/getPhysicalRing';
import { isSovereignCloudInfraEnabled } from './isSovereignCloudInfraEnabled';

/**
 * Returns whether the current app environment is sovereign, i.e. we loaded
 * the index.html from a sovereign cloud Outlook endpoint.
 */
export function isSovereignAppEnvironment(): boolean {
    if (!isSovereignCloudInfraEnabled()) {
        return false;
    }

    const environment = getVariantEnvironment();
    return (
        environment !== 'Prod' &&
        environment !== 'GCCModerate' &&
        environment !== 'Dogfood' &&
        environment !== 'Unknown'
    );
}
